import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Product List
import ProductListProductsWidget from "Fratello/ProductList/Widgets/ProductsWidget";
import ProductListViewsProductsView from "Fratello/ProductList/Views/ProductsView";

ComponentRegistry.register({ProductListProductsWidget});
ComponentRegistry.register({ProductListViewsProductsView});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/ProductList.jsx